module.exports = __webpack_public_path__ + "img/不良司男.3c3925be.png";